import { useState } from "react";
import { Box, Checkbox, FormControlLabel } from "@mui/material";
import type { ValidationRules, ValidationRule } from "features/languages/types";
import { formatRule } from "features/languages/utils/rules";
import { checkboxValueStyle } from "features/languages/components/LanguageForm/styles";

export const ValidationRulesList = ({ validationRules, formik }: { validationRules: ValidationRules; formik: any }) => {
  const [allChecked, setAllChecked] = useState(
    validationRules.rules.every(rule => formik.values.rules.includes(rule.id)),
  );
  const handleCheckboxChange = (event: React.SyntheticEvent, isChecked: boolean) => {
    const { value } = event.target as HTMLInputElement;

    if (value === "selectAllRules") {
      setAllChecked(isChecked);

      if (isChecked) {
        formik.setFieldValue(
          "rules",
          validationRules.rules.map(rule => rule.id),
        );
      } else {
        formik.setFieldValue("rules", []);
      }
      return;
    }

    const ruleId = Number(value);
    const { rules } = formik.values;

    if (isChecked) {
      formik.setFieldValue("rules", [...rules, ruleId]);
    } else {
      formik.setFieldValue(
        "rules",
        rules.filter((id_: number) => id_ !== ruleId),
      );
    }
  };

  return (
    <>
      <Box sx={{ display: "flex", pb: 1, alignItems: "center" }}>
        <Box sx={{ pr: 4 }}>Validation Rules:</Box>
        <Box>
          <FormControlLabel
            control={<Checkbox checked={allChecked} onChange={handleCheckboxChange} />}
            label="Check All"
            value="selectAllRules"
          />
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
        {validationRules.rules.map((rule: ValidationRule) => (
          <Box key={rule.id} sx={checkboxValueStyle}>
            <FormControlLabel
              onChange={handleCheckboxChange}
              control={<Checkbox />}
              // eslint-disable-next-line react/no-danger
              label={<div dangerouslySetInnerHTML={{ __html: formatRule(rule.rule) }} />}
              checked={formik.values.rules.includes(rule.id)}
              value={rule.id}
            />
          </Box>
        ))}
      </Box>
    </>
  );
};
